import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, FacebookAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBFRA8aNSuzd2_laFHj9EbwSHdfQCpnkn4",
  authDomain: "aio-india-df174.firebaseapp.com",
  projectId: "aio-india-df174",
  storageBucket: "aio-india-df174.firebasestorage.app",
  messagingSenderId: "621704774053",
  appId: "1:621704774053:android:035f86a9b249e8d64c284c",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const facebookProvider = new FacebookAuthProvider();
export default app;
